(function () {
  'use strict';

  // Cable check: see snippets/cable-check.liquid. Settings (which adapters,
  // which cables, the discount amount) come from snippets/cable-check-config.liquid.

  var cfgEl = document.getElementById('CableCheckConfig');
  if (!cfgEl) return;
  var CFG;
  try {
    CFG = JSON.parse(cfgEl.textContent);
  } catch (e) {
    return;
  }
  if (!CFG.cables || !CFG.cables.length) return;

  var API = 'https://vdfgvxqwcjdupvtjhnmy.supabase.co/functions/v1/compatibility-api?action=devices';
  var ANON = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZkZmd2eHF3Y2pkdXB2dGpobm15Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMzNjEwNzUsImV4cCI6MjA4ODkzNzA3NX0.EKFuutkb7vGysPMA3XsVuyuMbHCTalCVNETQqSZQEkE';
  var DISMISSED_KEY = 'cableCheckDismissed';
  var OTHER = '__other__';
  var LOOKUP = '__lookup__';
  var DRAWER_SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  var CABLES = CFG.cables.filter(function (c) { return c.available; });
  var ALL_CABLE_IDS = CFG.cables.map(function (c) { return String(c.id); });

  // ---------- shared helpers ----------

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function isAdapter(id) {
    return Object.prototype.hasOwnProperty.call(CFG.adapters, String(id));
  }

  function isCable(id) {
    return ALL_CABLE_IDS.indexOf(String(id)) !== -1;
  }

  function cableById(id) {
    return CABLES.filter(function (c) { return String(c.id) === String(id); })[0] || null;
  }

  function cableBySku(sku) {
    return CABLES.filter(function (c) { return c.sku === sku; })[0] || null;
  }

  // One cable per USB-C adapter. False once the shopper has said their
  // device is USB-C (cart attribute, so it survives reloads and devices).
  function needsCable(lines, saidUsbc) {
    if (saidUsbc) return false;
    var adapters = 0;
    var cables = 0;
    lines.forEach(function (l) {
      if (isAdapter(l.id)) adapters += l.qty;
      else if (isCable(l.id)) cables += l.qty;
    });
    return adapters > cables;
  }

  function dismissed() {
    try { return sessionStorage.getItem(DISMISSED_KEY) === '1'; } catch (e) { return false; }
  }

  function setDismissed() {
    try { sessionStorage.setItem(DISMISSED_KEY, '1'); } catch (e) {}
  }

  function cartUrl(route, fallback) {
    return ((window.routes && window.routes[route]) || fallback) + '.js';
  }

  function postJson(url, body) {
    return originalFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  function addCable(cableId, sections, sectionsUrl) {
    var body = { items: [{ id: Number(cableId), quantity: 1 }] };
    if (sections) {
      body.sections = sections;
      body.sections_url = sectionsUrl || window.location.pathname;
    }
    return postJson(cartUrl('cart_add_url', '/cart/add'), body);
  }

  function markUsbc(sections, sectionsUrl) {
    var attrs = {};
    attrs[CFG.attribute] = '1';
    var body = { attributes: attrs };
    if (sections) {
      body.sections = sections;
      body.sections_url = sectionsUrl || window.location.pathname;
    }
    return postJson(cartUrl('cart_update_url', '/cart/update'), body);
  }

  function renderDrawer(sections) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && sections && typeof drawer.renderContents === 'function') {
      drawer.renderContents({ sections: sections });
    }
  }

  function fetchDrawerSections() {
    return originalFetch(window.location.pathname + '?sections=' + DRAWER_SECTIONS.join(','))
      .then(function (r) { return r.ok ? r.json() : null; });
  }

  // ---------- device lookup (same data and mapping as the USB-C converter page) ----------

  var devicesPromise = null;
  function loadDevices() {
    if (!devicesPromise) {
      devicesPromise = originalFetch(API, { headers: { apikey: ANON, Authorization: 'Bearer ' + ANON } })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (data) { return data.devices || []; })
        .catch(function (err) {
          devicesPromise = null;
          throw err;
        });
    }
    return devicesPromise;
  }

  // connection_type (+ brand) -> 'usbc', a cable SKU, or null (we don't know).
  function cableSkuFor(d) {
    var c = String(d.connection_type || '').toLowerCase();
    var brand = String(d.manufacturer || '').toLowerCase();
    if (/^usb-?c\b/.test(c)) return 'usbc';
    if (/mini-?\s?usb/.test(c)) return 'USB-C-MINI';
    if (/micro-?\s?usb/.test(c)) return 'USB-C-MICRO';
    if (/rj-?\s?11/.test(c)) return '850061365392';
    if (brand === 'blackvue') return 'USB-C-DC-BV';
    if (brand === 'thinkware' && /dc|barrel/.test(c)) return 'USB-C-DC-TW';
    return null;
  }

  function deviceName(d) {
    return [d.manufacturer, d.model_sku || d.product_name].filter(Boolean).join(' ');
  }

  // Wires a brand + model pair of selects. onResult gets one of:
  // {kind:'cable', cable, name} {kind:'usbc', name} {kind:'none'} {kind:'error'} {kind:'clear'}
  function wireLookup(brandSel, modelSel, onResult) {
    var devices = null;

    brandSel.innerHTML = '<option value="">Loading…</option>';
    brandSel.disabled = true;
    modelSel.innerHTML = '<option value="">Model</option>';
    modelSel.disabled = true;

    loadDevices()
      .then(function (list) {
        devices = list;
        var brands = {};
        list.forEach(function (d) { if (d.manufacturer) brands[d.manufacturer] = true; });
        var names = Object.keys(brands).sort(function (a, b) { return a.localeCompare(b); });
        brandSel.innerHTML = '<option value="">Brand</option>' +
          names.map(function (n) { return '<option>' + esc(n) + '</option>'; }).join('') +
          '<option value="' + OTHER + '">Other / not listed</option>';
        brandSel.disabled = false;
      })
      .catch(function () {
        brandSel.innerHTML = '<option value="">Unavailable</option>';
        onResult({ kind: 'error' });
      });

    brandSel.addEventListener('change', function () {
      modelSel.innerHTML = '<option value="">Model</option>';
      modelSel.disabled = true;
      if (brandSel.value === OTHER) { onResult({ kind: 'none' }); return; }
      onResult({ kind: 'clear' });
      if (!brandSel.value || !devices) return;
      var models = devices
        .filter(function (d) { return d.manufacturer === brandSel.value; })
        .sort(function (a, b) {
          return String(a.model_sku || a.product_name).localeCompare(String(b.model_sku || b.product_name), undefined, { numeric: true });
        });
      modelSel.innerHTML = '<option value="">Model</option>' +
        models.map(function (d) { return '<option value="' + esc(d.id) + '">' + esc(d.model_sku || d.product_name) + '</option>'; }).join('') +
        '<option value="' + OTHER + '">Other / not listed</option>';
      modelSel.disabled = false;
    });

    modelSel.addEventListener('change', function () {
      if (modelSel.value === OTHER) { onResult({ kind: 'none' }); return; }
      var d = devices && devices.filter(function (x) { return String(x.id) === modelSel.value; })[0];
      if (!d) { onResult({ kind: 'clear' }); return; }
      var sku = cableSkuFor(d);
      if (sku === 'usbc') { onResult({ kind: 'usbc', name: deviceName(d) }); return; }
      var cable = sku ? cableBySku(sku) : null;
      var soldOut = sku && !cable ? CFG.cables.filter(function (c) { return c.sku === sku; })[0] : null;
      if (cable) onResult({ kind: 'cable', cable: cable, name: deviceName(d) });
      else if (soldOut) onResult({ kind: 'soldout', cable: soldOut, name: deviceName(d) });
      else onResult({ kind: 'none' });
    });
  }

  // ---------- icons ----------

  var ICON = {
    check: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M8 12l3 3 5-6"/></svg>',
    info: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16h.01"/></svg>',
    close: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>',
    back: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>',
    usbc: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="6" y="9" width="12" height="6" rx="3"/><path d="M9 12h6"/></svg>',
    plug: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 3v5M15 3v5M6 8h12v3a6 6 0 0 1-12 0z"/><path d="M12 17v4"/></svg>',
    search: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="6"/><path d="M20 20l-4.5-4.5"/></svg>',
    'USB-C-MINI': '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><path d="M7 9h10l-2 6H9z"/></svg>',
    'USB-C-MICRO': '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><path d="M6 10h12l-2 4H8z"/></svg>',
    '850061365392': '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><rect x="7" y="6" width="10" height="12" rx="1"/><path d="M10 6v3M12 6v3M14 6v3"/></svg>',
    dc: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="1.5"/></svg>',
  };
  function plugIcon(sku) { return ICON[sku] || ICON.dc; }

  function priceHtml(cable) {
    return '<span class="cc-price">' + esc(cable.sale) + '</span> <s class="cc-was">' + esc(cable.price) + '</s>';
  }

  // ---------- pop-up (Option A) ----------

  var modal = null;
  var resolveChoice = null;
  var popupOpen = false;
  var history = [];
  var selectedCable = null;

  var SALE = CABLES[0].sale;
  var WAS = CABLES[0].price;

  function buildModal() {
    if (modal) return;
    modal = document.createElement('div');
    modal.id = 'CableCheck';
    modal.className = 'cc-overlay';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="cc-dialog" role="dialog" aria-modal="true" aria-labelledby="CableCheckTitle" tabindex="-1">' +
        '<div class="cc-bar">' +
          '<button type="button" class="cc-back" data-cc="back">' + ICON.back + 'Back</button>' +
          '<span class="cc-added">' + ICON.check + '<span data-cc-added></span></span>' +
          '<button type="button" class="cc-close" data-cc="skip" aria-label="Close">' + ICON.close + '</button>' +
        '</div>' +

        '<div class="cc-screen" data-screen="start">' +
          '<h2 class="cc-title" id="CableCheckTitle">Quick check: what plug does your dash cam or device use?</h2>' +
          '<p class="cc-text">Dongar adapters power your dash cam or device over USB-C. If it has a different plug, you\'ll need a converter cable.</p>' +
          '<div class="cc-choices">' +
            '<button type="button" class="cc-choice" data-cc="usbc">' + ICON.usbc + '<span><span class="cc-choice__t">USB-C</span><span class="cc-choice__d">I\'m all set, no cable needed</span></span></button>' +
            '<button type="button" class="cc-choice" data-cc="plug">' + ICON.plug + '<span><span class="cc-choice__t">A different plug</span><span class="cc-choice__d">Mini USB, Micro USB, RJ11, or DC barrel</span></span></button>' +
            '<button type="button" class="cc-choice" data-cc="lookup">' + ICON.search + '<span><span class="cc-choice__t">I\'m not sure</span><span class="cc-choice__d">Look up your device by brand and model</span></span></button>' +
          '</div>' +
          '<div class="cc-foot"><span>Cables are <span class="cc-lime">' + esc(CFG.discount) + ' off</span> with your adapter.</span><button type="button" class="cc-link" data-cc="skip">Skip to cart</button></div>' +
        '</div>' +

        '<div class="cc-screen" data-screen="plug" hidden>' +
          '<h2 class="cc-title">Pick your plug</h2>' +
          '<p class="cc-text cc-pricing">Converter cable <span class="cc-price">' + esc(SALE) + '</span> <s class="cc-was">' + esc(WAS) + '</s> <span class="cc-badge">' + esc(CFG.discount) + ' off with your adapter</span></p>' +
          '<div class="cc-plugs">' +
            CFG.cables.map(function (c) {
              if (!c.available) {
                return '<button type="button" class="cc-plug cc-plug--soldout" disabled aria-label="' + esc(c.label) + ', out of stock">' +
                  plugIcon(c.sku) + '<span>' + esc(c.label) + '</span><span class="cc-soldout">Out of stock</span></button>';
              }
              return '<button type="button" class="cc-plug" aria-pressed="false" data-cc-plug="' + c.id + '">' + plugIcon(c.sku) + '<span>' + esc(c.label) + '</span></button>';
            }).join('') +
            '<button type="button" class="cc-plug cc-plug--lookup" data-cc="lookup">' + ICON.search + '<span>Not sure? Look it up</span></button>' +
          '</div>' +
          '<p class="cc-error" data-cc-plug-error hidden>Choose a plug first.</p>' +
          '<button type="button" class="cc-primary" data-cc="add-selected">Add cable</button>' +
          '<button type="button" class="cc-link cc-center" data-cc="skip">No thanks, view cart</button>' +
        '</div>' +

        '<div class="cc-screen" data-screen="lookup" hidden>' +
          '<h2 class="cc-title">Look up your device</h2>' +
          '<p class="cc-text">Choose your dash cam or device and we\'ll tell you which plug it uses.</p>' +
          '<div class="cc-selects">' +
            '<label class="cc-field">Brand<select data-cc-brand></select></label>' +
            '<label class="cc-field">Model<select data-cc-model></select></label>' +
          '</div>' +
          '<div class="cc-result" data-cc-result aria-live="polite" hidden></div>' +
          '<div class="cc-actions" data-cc-actions></div>' +
          '<button type="button" class="cc-link cc-center" data-cc="skip">No thanks, view cart</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (evt) {
      if (evt.target === modal) { close({ type: 'skip' }); return; }
      var btn = evt.target.closest('[data-cc], [data-cc-plug]');
      if (!btn) return;
      if (btn.hasAttribute('data-cc-plug')) { pickPlug(btn.getAttribute('data-cc-plug')); return; }
      var action = btn.getAttribute('data-cc');
      if (action === 'skip') close({ type: 'skip' });
      else if (action === 'usbc') close({ type: 'usbc' });
      else if (action === 'plug') go('plug');
      else if (action === 'lookup') go('lookup');
      else if (action === 'back') back();
      else if (action === 'add-selected') {
        if (!selectedCable) { modal.querySelector('[data-cc-plug-error]').hidden = false; return; }
        close({ type: 'cable', id: selectedCable.id });
      } else if (action === 'add-cable') close({ type: 'cable', id: btn.getAttribute('data-id') });
      else if (action === 'contact') { setDismissed(); close({ type: 'skip' }); }
    });

    modal.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape') { evt.stopPropagation(); close({ type: 'skip' }); return; }
      if (evt.key !== 'Tab') return;
      var focusables = Array.prototype.filter.call(
        modal.querySelectorAll('button, select, a[href]'),
        function (el) { return !el.disabled && el.offsetParent !== null; }
      );
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (evt.shiftKey && document.activeElement === first) { evt.preventDefault(); last.focus(); }
      else if (!evt.shiftKey && document.activeElement === last) { evt.preventDefault(); first.focus(); }
    });

    wireLookup(modal.querySelector('[data-cc-brand]'), modal.querySelector('[data-cc-model]'), showLookupResult);
  }

  function pickPlug(id) {
    selectedCable = cableById(id);
    Array.prototype.forEach.call(modal.querySelectorAll('[data-cc-plug]'), function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-cc-plug') === String(id)));
    });
    modal.querySelector('[data-cc-plug-error]').hidden = true;
    modal.querySelector('[data-cc="add-selected"]').textContent =
      selectedCable ? 'Add ' + selectedCable.label + ' cable, ' + selectedCable.sale : 'Add cable';
  }

  function showLookupResult(res) {
    var box = modal.querySelector('[data-cc-result]');
    var actions = modal.querySelector('[data-cc-actions]');
    box.className = 'cc-result';
    if (res.kind === 'clear') { box.hidden = true; actions.innerHTML = ''; return; }
    box.hidden = false;
    if (res.kind === 'cable') {
      box.classList.add('cc-result--match');
      box.innerHTML = ICON.check + '<span><strong>Your ' + esc(res.name) + ' uses ' + esc(res.cable.label) + '</strong>' +
        'You\'ll need the ' + esc(res.cable.label) + ' converter cable to connect it to your Dongar adapter.</span>';
      actions.innerHTML = '<button type="button" class="cc-primary" data-cc="add-cable" data-id="' + res.cable.id + '">Add ' + esc(res.cable.label) + ' cable, ' + esc(res.cable.sale) + '</button>';
    } else if (res.kind === 'usbc') {
      box.classList.add('cc-result--match');
      box.innerHTML = ICON.check + '<span><strong>Your ' + esc(res.name) + ' uses USB-C</strong>You\'re all set. It plugs straight into your Dongar adapter, no cable needed.</span>';
      actions.innerHTML = '<button type="button" class="cc-primary" data-cc="usbc">Continue to cart</button>';
    } else if (res.kind === 'soldout') {
      box.innerHTML = ICON.info + '<span><strong>Your ' + esc(res.name) + ' uses ' + esc(res.cable.label) + '</strong>' +
        'That cable is sold out right now. Contact us and we\'ll let you know when it\'s back or suggest another option.</span>';
      actions.innerHTML = '<a class="cc-secondary" href="' + esc(CFG.contactUrl) + '" data-cc="contact">Contact us</a>';
    } else {
      box.innerHTML = ICON.info + '<span><strong>' + (res.kind === 'error' ? 'We couldn\'t load the device list right now' : 'We don\'t have that device on file yet') + '</strong>' +
        'Check the plug on your device\'s power cord and pick it below, or send us the brand and model and we\'ll tell you which cable fits.</span>';
      actions.innerHTML = '<div class="cc-pair"><button type="button" class="cc-primary" data-cc="plug">Pick my plug</button>' +
        '<a class="cc-secondary" href="' + esc(CFG.contactUrl) + '" data-cc="contact">Contact us</a></div>';
    }
  }

  function show(screen) {
    Array.prototype.forEach.call(modal.querySelectorAll('.cc-screen'), function (s) {
      s.hidden = s.getAttribute('data-screen') !== screen;
    });
    modal.querySelector('.cc-back').hidden = screen === 'start';
    modal.querySelector('.cc-added').hidden = screen !== 'start';
    // Focus the dialog itself, not its first option, so nothing looks pre-selected.
    modal.querySelector('.cc-dialog').focus();
    modal.querySelector('.cc-dialog').scrollTop = 0;
  }

  function go(screen) {
    history.push(screen);
    show(screen);
  }

  function back() {
    history.pop();
    show(history[history.length - 1] || 'start');
  }

  function ask(addedLabel) {
    buildModal();
    return new Promise(function (resolve) {
      resolveChoice = resolve;
      popupOpen = true;
      history = ['start'];
      selectedCable = null;
      pickPlug(null);
      modal.querySelector('[data-cc-added]').textContent = addedLabel + ' added to cart';
      var upsell = document.getElementById('ClassicUpsellModal');
      if (upsell && upsell.hasAttribute('open') && typeof upsell.hide === 'function') upsell.hide();
      document.body.appendChild(modal);
      modal.hidden = false;
      document.documentElement.classList.add('cc-lock');
      show('start');
    });
  }

  function close(choice) {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    popupOpen = false;
    document.documentElement.classList.remove('cc-lock');
    setDismissed();
    var resolve = resolveChoice;
    resolveChoice = null;
    if (resolve) resolve(choice);
  }

  // ---------- add-to-cart hook ----------

  function parseAdd(body) {
    if (body instanceof FormData) {
      var id = body.get('id');
      return {
        ids: id != null ? [String(id)] : [],
        sections: body.get('sections') || null,
        sectionsUrl: body.get('sections_url') || null,
      };
    }
    if (typeof body !== 'string') return null;
    var data;
    try { data = JSON.parse(body); } catch (e) { return null; }
    var ids = [];
    if (data && Array.isArray(data.items)) data.items.forEach(function (i) { if (i && i.id != null) ids.push(String(i.id)); });
    else if (data && data.id != null) ids.push(String(data.id));
    return { ids: ids, sections: data.sections || null, sectionsUrl: data.sections_url || null };
  }

  function adapterLabel(ids) {
    var id = ids.filter(isAdapter)[0];
    var a = CFG.adapters[id];
    return a.variant ? a.product + ', ' + a.variant : a.product;
  }

  function withSections(added, sections) {
    var merged = {};
    Object.keys(added).forEach(function (k) { merged[k] = added[k]; });
    merged.sections = sections;
    return new Response(JSON.stringify(merged), { status: 200, headers: { 'Content-Type': 'application/json' } });
  }

  function finish(choice, added, req, response) {
    var work;
    if (choice.type === 'cable') work = addCable(choice.id, req.sections, req.sectionsUrl);
    else if (choice.type === 'usbc') work = markUsbc(req.sections, req.sectionsUrl);
    else return response;

    return work
      .then(function (result) {
        // The caller asked for re-rendered drawer sections (Dawn's product
        // form): hand it the fresh ones so the drawer shows the cable too.
        if (req.sections && result.sections) return withSections(added, result.sections);
        // A caller that doesn't render the drawer (e.g. the Classic+ upsell):
        // refresh and open it ourselves.
        fetchDrawerSections().then(renderDrawer);
        return response;
      })
      .catch(function (err) {
        console.warn('[cable-check]', err);
        return response;
      });
  }

  var originalFetch = window.fetch;
  if (typeof originalFetch !== 'function') return;
  originalFetch = originalFetch.bind(window);

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (popupOpen || !/\/cart\/add(\.js)?(\?|$)/.test(url) || dismissed()) {
      return originalFetch(input, init);
    }
    var req = parseAdd(init && init.body);
    if (!req || !req.ids.some(isAdapter)) return originalFetch(input, init);

    return originalFetch(input, init).then(function (response) {
      if (!response.ok) return response;
      return response.clone().json()
        .then(function (added) {
          if (!added || added.status) return response;
          return originalFetch(cartUrl('cart_url', '/cart'), { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var lines = cart.items.map(function (i) { return { id: i.variant_id, qty: i.quantity }; });
              var saidUsbc = !!(cart.attributes && cart.attributes[CFG.attribute]);
              if (!needsCable(lines, saidUsbc)) return response;
              return ask(adapterLabel(req.ids)).then(function (choice) {
                return finish(choice, added, req, response);
              });
            });
        })
        .catch(function (err) {
          console.warn('[cable-check]', err);
          return response;
        });
    });
  };

  // ---------- cart drawer card (Option B fallback) ----------

  if (!customElements.get('cable-check-card')) {
    customElements.define(
      'cable-check-card',
      class CableCheckCard extends HTMLElement {
        connectedCallback() {
          var lines;
          try { lines = JSON.parse(this.dataset.lines || '[]'); } catch (e) { lines = []; }
          if (!needsCable(lines, this.dataset.usbc === 'true')) { this.hidden = true; return; }

          // cart-drawer-items reacts to ANY bubbling 'change' by running a
          // quantity update (see cart-drawer-extras.js). Keep ours inside.
          this.addEventListener('change', function (evt) { evt.stopPropagation(); });
          this.addEventListener('click', this.onClick.bind(this));
          this.renderPlugs();
          this.hidden = false;
        }

        renderPlugs() {
          this.innerHTML =
            '<div class="cc-card__head">' + ICON.info +
              '<div><p class="cc-card__title">Does your dash cam or device plug in with USB-C?</p>' +
              '<p class="cc-card__text">If not, add a converter cable: ' + priceHtml(CABLES[0]) + ' with your adapter.</p></div>' +
            '</div>' +
            '<div class="cc-card__row">' +
              '<label class="visually-hidden" for="CableCheckCardPlug">Your device\'s plug</label>' +
              '<select id="CableCheckCardPlug" class="cc-card__select">' +
                '<option value="">Choose your plug</option>' +
                CFG.cables.map(function (c) {
                  return c.available
                    ? '<option value="' + c.id + '">' + esc(c.label) + '</option>'
                    : '<option value="" disabled>' + esc(c.label) + ' (out of stock)</option>';
                }).join('') +
                '<option value="' + LOOKUP + '">Not sure, look it up</option>' +
              '</select>' +
              '<button type="button" class="cc-card__add" data-cc="card-add">Add</button>' +
            '</div>' +
            '<p class="cc-error" data-cc-card-error hidden>Choose a plug first.</p>' +
            '<button type="button" class="cc-link" data-cc="card-usbc">My device uses USB-C</button>';

          var select = this.querySelector('select');
          var self = this;
          select.addEventListener('change', function () {
            self.querySelector('[data-cc-card-error]').hidden = true;
            if (select.value === LOOKUP) self.renderLookup();
          });
        }

        renderLookup() {
          this.innerHTML =
            '<div class="cc-card__lookuphead"><p class="cc-card__title">Look up your device</p>' +
              '<button type="button" class="cc-link" data-cc="card-plugs">Back to plugs</button></div>' +
            '<label class="cc-field">Brand<select class="cc-card__select" data-cc-brand></select></label>' +
            '<label class="cc-field">Model<select class="cc-card__select" data-cc-model></select></label>' +
            '<div class="cc-card__result" data-cc-result aria-live="polite" hidden></div>' +
            '<div data-cc-actions></div>';

          var self = this;
          wireLookup(this.querySelector('[data-cc-brand]'), this.querySelector('[data-cc-model]'), function (res) {
            var box = self.querySelector('[data-cc-result]');
            var actions = self.querySelector('[data-cc-actions]');
            if (res.kind === 'clear') { box.hidden = true; actions.innerHTML = ''; return; }
            box.hidden = false;
            if (res.kind === 'cable') {
              box.innerHTML = ICON.check + '<span><strong>Your ' + esc(res.name) + ' uses ' + esc(res.cable.label) + '.</strong> You\'ll need the ' + esc(res.cable.label) + ' converter cable.</span>';
              actions.innerHTML = '<button type="button" class="cc-card__add cc-card__add--full" data-cc="card-add" data-id="' + res.cable.id + '">Add ' + esc(res.cable.label) + ' cable, ' + esc(res.cable.sale) + '</button>';
            } else if (res.kind === 'usbc') {
              box.innerHTML = ICON.check + '<span><strong>Your ' + esc(res.name) + ' uses USB-C.</strong> You\'re all set, no cable needed.</span>';
              actions.innerHTML = '<button type="button" class="cc-card__add cc-card__add--full" data-cc="card-usbc">Got it</button>';
            } else if (res.kind === 'soldout') {
              box.innerHTML = ICON.info + '<span><strong>Your ' + esc(res.name) + ' uses ' + esc(res.cable.label) + '.</strong> That cable is sold out right now. <a href="' + esc(CFG.contactUrl) + '">Contact us</a> and we\'ll suggest another option.</span>';
              actions.innerHTML = '';
            } else {
              box.innerHTML = ICON.info + '<span><strong>' + (res.kind === 'error' ? 'We couldn\'t load the device list.' : 'We don\'t have that device on file yet.') + '</strong> Check the plug on its power cord, or <a href="' + esc(CFG.contactUrl) + '">contact us</a> and we\'ll tell you which cable fits.</span>';
              actions.innerHTML = '<button type="button" class="cc-card__add cc-card__add--full" data-cc="card-plugs">Pick my plug</button>';
            }
          });
        }

        onClick(evt) {
          var btn = evt.target.closest('[data-cc]');
          if (!btn) return;
          var action = btn.getAttribute('data-cc');
          if (action === 'card-plugs') { this.renderPlugs(); return; }
          if (action === 'card-usbc') { this.busy(btn); markUsbc(DRAWER_SECTIONS).then(this.done.bind(this), this.fail.bind(this, btn)); return; }
          if (action === 'card-add') {
            var id = btn.getAttribute('data-id');
            if (!id) {
              var select = this.querySelector('select');
              id = select && select.value !== LOOKUP ? select.value : '';
            }
            if (!id) { var err = this.querySelector('[data-cc-card-error]'); if (err) err.hidden = false; return; }
            this.busy(btn);
            addCable(id, DRAWER_SECTIONS).then(this.done.bind(this), this.fail.bind(this, btn));
          }
        }

        busy(btn) {
          btn.disabled = true;
          btn.setAttribute('aria-busy', 'true');
        }

        done(result) {
          renderDrawer(result.sections);
        }

        fail(btn, err) {
          console.warn('[cable-check]', err);
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
        }
      }
    );
  }
})();
